import React, { useEffect , useState } from 'react';
import { NavLink ,Link, useMatch } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


function Header() {
  const isBlogDetail = useMatch('/blog/:id');
  const [query, setQuery] = useState('');
  const navigate = useNavigate();
  

  useEffect(() => {
    const handleDocumentClick = (event) => {
      const navBar = document.getElementById('navbarsExampleDefault');
      const isClickInside = navBar.contains(event.target) || event.target.classList.contains('navbar-toggler');
  
      if (!isClickInside) {
        closeMenu();
      }
    };

    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
    
    
  }, []);

const handleSubmit = (event) => {
  event.preventDefault();
  if (query.trim()) {
      navigate(`/?q=${query}`);
  }
  setQuery("")
  closeMenu()
};

  const closeMenu = () => {
    const navBar = document.getElementById('navbarsExampleDefault');
    if (navBar.classList.contains('show')) {
      navBar.classList.remove('show');
    }
  };

  return (
    <header>
      <nav className="navbar navbar-expand-lg navbar-dark fixed-top bg-dark">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            さんまの技術ブログ
          </Link>
          
          <button type="button" className="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="ナビゲーションの切替">
          <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarsExampleDefault">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink 
                  className={({ isActive }) => "nav-link " + (isActive ? " active" : "")} 
                  to="/"
                  onClick={closeMenu}
                >
                  ブログ
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink 
                  className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} 
                  to="/profile"
                  onClick={closeMenu}
                >
                  プロフィール
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink 
                  className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} 
                  to="/portfolio"
                  onClick={closeMenu}
                >
                  ポートフォリオ
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink 
                  className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} 
                  to="/privacypolicy"
                  onClick={closeMenu}
                >
                  プライバシーポリシー
                </NavLink>
              </li>
              {/* <li className="nav-item">
                <NavLink 
                  className={({ isActive }) => "nav-link" + (isActive ? " active" : "")} 
                  to="/contact"
                  onClick={closeMenu}
                >
                  問い合わせ
                </NavLink>
              </li> */}
            </ul>

            <div className="ms-auto">
                <form className="d-flex" role="search" onSubmit={handleSubmit}>
                  <input type="text" className="form-control me-2" name="q" placeholder="記事を検索" value={query} onChange={(e) => setQuery(e.target.value)}/>
                  <button type="submit" className="btn btn-success no-wrap-button">検索</button>
                </form>
            </div>

            
          </div>
        </div>
        
      </nav>

      {isBlogDetail ? (
        <div className="header-nav-spacer" aria-hidden="true" />
      ) : (
        <div className="jumbotron" aria-hidden="true" />
      )}
    </header>
  );
}

export default Header;
